import type { SaStatusBadgeVariant } from '../design-system/components'
import type { PlatformAccountStatus } from './userStatus.types'

export const ACCOUNT_STATUS_LABELS: Record<PlatformAccountStatus, string> = {
  active: 'Actief',
  suspended: 'Geschorst',
  banned: 'Geblokkeerd',
}

export function parsePlatformAccountStatus (value: unknown): PlatformAccountStatus {
  if (value === 'suspended' || value === 'banned') return value
  return 'active'
}

export function getAccountStatusLabel (status: PlatformAccountStatus): string {
  return ACCOUNT_STATUS_LABELS[status]
}

export function getAccountStatusBadgeVariant (status: PlatformAccountStatus): SaStatusBadgeVariant {
  switch (status) {
    case 'suspended':
      return 'warning'
    case 'banned':
      return 'danger'
    default:
      return 'success'
  }
}

export function canManageUserStatus (params: {
  targetUserId: string
  targetRole: string
  currentUserId: string | null
}): boolean {
  if (!params.currentUserId) return false
  if (params.targetUserId === params.currentUserId) return false
  if (params.targetRole === 'superadmin') return false
  return true
}

export function getUserStatusActionErrorMessage (error: unknown): string {
  if (!(error instanceof Error)) return 'Actie mislukt'
  const message = error.message.toLowerCase()
  if (message.includes('cannot_manage_own_status')) {
    return 'Je kunt je eigen accountstatus niet wijzigen.'
  }
  if (message.includes('cannot_manage_superadmin')) {
    return 'Superadmin-accounts kunnen niet worden gewijzigd.'
  }
  if (message.includes('user_not_found')) {
    return 'Gebruiker niet gevonden.'
  }
  return error.message
}
